import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleError } from "../../hooks/useApi";
import { useGetUserQuery } from "../../redux/slices/api/userApi";
import { selectGeneral, setShowAuthModal } from "../../redux/slices/generalSlice";

const LikeButton = ({
  containerClass = "w-10 h-12",
  heartClass = "w-20 h-20",
  countClass = "-mt-[24px] text-sm",
  likes,
  useLikeMutation,
  useDislikeMutation,
  id,
  likeType = "project",
  onToggleLike,
}) => {
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(likes);
  const dispatch = useDispatch();
  
  // Use simple login check - no SIWE signature needed for likes
  const { isLoggedIn } = useSelector(selectGeneral);
  
  const [likeMutation, { isLoading: likeLoading }] = useLikeMutation();
  const [dislikeMutation, { isLoading: dislikeLoading }] = useDislikeMutation();
  const {
    isLoading: getMeLoading,
    data,
    refetch: refetchUserData,
  } = useGetUserQuery(undefined, { skip: !isLoggedIn });
  const { user } = data ?? {};
  const types = { project: "liked_projects", result: "liked_results", community: "liked_communities" };

  useEffect(() => {
    const findLike = user?.[types[likeType]]?.find((item) => item?._id === id || item?.toString() === id);
    if (findLike) setIsLiked(true);
    else setIsLiked(false);
    // eslint-disable-next-line
  }, [user, id, likeType]);

  const setLike = () => {
    setIsLiked(!isLiked);
    setLikeCount(isLiked ? likeCount - 1 : likeCount + 1);
  };
  
  const handleToggleLike = async () => {
    // Check if user is logged in
    if (!isLoggedIn) {
      dispatch(setShowAuthModal({ show: true }));
      return;
    }
    
    // Check if user has completed profile (profile_step >= 1)
    if (user && user.profile_step < 1) {
      handleError(
        { message: "Please complete your profile before liking content" },
        "Profile Required",
        true
      );
      return;
    }
    
    try {
      setLike();
      if (isLiked) await dislikeMutation({ id }).unwrap();
      else await likeMutation({ id }).unwrap();
      onToggleLike?.();
      refetchUserData();
    } catch (error) {
      // Revert on error
      setLike();
      handleError(error, null, false);
    }
  };
  return (
    <div className={` ${containerClass} flex flex-col items-center `}>
      <div className="relative">
        <div className="w-full flex flex-col justify-center items-center absolute -translate-y-[31%]">
          <button
            disabled={likeLoading || dislikeLoading || getMeLoading}
            onClick={(e) => {
              e.stopPropagation();
              if (!likeLoading && !dislikeLoading) {
                handleToggleLike();
              }
            }}
            className={`heart ${heartClass} ${
              isLiked && "is_animating"
            } cursor-pointer `}
          ></button>{" "}
          <span className={`${countClass}`}>{likeCount}</span>
        </div>{" "}
      </div>
    </div>
  );
};

export default LikeButton;
